import { Controller } from "@hotwired/stimulus"

// QRC-15 — the code beside the field, following what is typed. Whether 180
// characters still scan is the one thing about a spot nobody has in his head,
// and the only way to see it is to look at the pattern.
//
// The code is drawn by the server and never here (QRC-20): the generation
// belongs to the system, and a second implementation in the browser would be a
// second answer to the same question — the picture in the form would then be a
// promise about a file somebody else writes.
export default class extends Controller {
  static targets = ["preview"]
  static values = { url: String, delay: { type: Number, default: 400 } }

  connect() {
    this.element.addEventListener("input", this.schedule)
    this.element.addEventListener("change", this.schedule)
  }

  disconnect() {
    clearTimeout(this.timer)
    this.element.removeEventListener("input", this.schedule)
    this.element.removeEventListener("change", this.schedule)
  }

  // Typing is not a request per keystroke: the pattern is redrawn once somebody
  // stops, which is also when it becomes worth looking at.
  schedule = () => {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.draw(), this.delayValue)
  }

  async draw() {
    if (!this.hasPreviewTarget) return

    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
        Accept: "text/html"
      },
      body: this.body()
    })
    if (!response.ok) return

    this.previewTarget.innerHTML = await response.text()
  }

  // The fields of this placeholder, under the names the server knows them by.
  // `spot_version[slot_contents_attributes][3][target_url]` is what the form
  // posts; what the preview needs is the bare `target[url]`, so the mapping
  // happens here rather than in a second set of inputs nobody would keep in
  // step with the first.
  body() {
    const data = new FormData()

    this.element.querySelectorAll("input, select, textarea").forEach((field) => {
      const name = field.name.match(/\[target_([a-z_]+)\]$/)
      if (!name) return
      if (field.type === "checkbox" && !field.checked) return

      data.append(`target[${name[1]}]`, field.value)
    })

    return data
  }
}
